import {
  CampaignFrequency,
  LivestockInsuranceTypes,
} from '@harvestiq/constants';
import { z } from '@harvestiq/zod';
import { campaignSchema } from './campaign';

export const getCampaignsRequestQuerySchema = z.object({
  searchText: z.string().optional(),
});
export type GetCampaignsRequestQuery = z.infer<
  typeof getCampaignsRequestQuerySchema
>;

export const getCampaignsResponseSchema = campaignSchema.array();
export type GetCampaignsResponse = z.output<typeof getCampaignsResponseSchema>;

export const getCampaignParamsSchema = z.object({
  campaignId: z.string().uuid(),
  userId: z.string().uuid().optional(),
});
export type GetCampaignParams = z.infer<typeof getCampaignParamsSchema>;

export const getActiveCampaignQueryParamsSchema = z.object({
  frequency: z.nativeEnum(CampaignFrequency),
  insuranceType: z.nativeEnum(LivestockInsuranceTypes),
});

export type GetActiveCampaignQueryParams = z.infer<
  typeof getActiveCampaignQueryParamsSchema
>;
